import get from 'transmute/get';
import { createSelector } from '@reduxjs/toolkit';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
export const getShowingHsBranding = createSelector(getLatestWidgetData, get('showingHsBranding'));